import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";

import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import "../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import "./UserProfile.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function BookList(props) {
  const [profiles, setProfiles] = useState();

  const [record, setRecord] = useState();

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [selectedPitcher, setSelectedPitcher] = useState(props.initialValue);
  const [initialValue, setInitialValue] = useState(props.initialValue);
  const [isLoading, setIsLoading] = useState();

  const handleIdBookChange = (event, newValue) => {
    console.log("Linetype", newValue.props.value);
    props.setIdUserProfileOnMem(event.target.value, props.row);

    setSelectedPitcher(newValue.props.value);
  };

  let history = useHistory();
  const useStyles = makeStyles({
    root: {
      width: "100%",
      overflowX: "auto",
    },
    table: {
      minWidth: 230,
    },
    tableHead: {
      background: "#3f51b5",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "darkcyan !important",
      },
    },

    tableRow: {
      "&:hover": {
        backgroundColor: "lightgrey !important",
      },
    },
    headerCell: {
      color: "white",
    },
  });

  const classes = useStyles();

  useEffect(() => {
    //Change for server api address
    setIsLoading(true);
    //Profile Props',props )
    const url = process.env.REACT_APP_API2_URL + "/User/UserProfile_GetList";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setRecord(data[0]);
        setProfiles(data);

        setIsLoading(false);
      });
  }, []);

  const printInputList = () => {
    return (
      <div>
        <FormControl
          className={`${classes.formControl} w-full`}
          size="small"
          variant="outlined"
        >
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            Profile User
          </InputLabel>
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={selectedPitcher}
            onChange={handleIdBookChange}
            displayEmpty
            className={classes.selectEmpty}
          >
            {profiles &&
              profiles.map((row) => (
                <MenuItem value={row.idUserProfile}>{row.profileName}</MenuItem>
              ))}
          </Select>
          <FormHelperText>User Profiles</FormHelperText>
        </FormControl>
      </div>
    );
  };

  if (props.isInput) {
    return printInputList();
  }
}

export default BookList;
